import { type Component, Show } from 'solid-js'
import { type KPI } from '../../../../features/analytics/domain/models/kpi'
import { Icon } from '@iconify-icon/solid'
import { Trans } from '@mbarzda/solid-i18next'
import { useNumberFormatter } from '../../../../shared/helpers/currency-formatter'
import ProgressRatio from '../ProgressRatio'

export interface ValueProgressCellProps {
  readonly kpi: KPI
  readonly warning?: boolean
}

const ValueProgressCell: Component<ValueProgressCellProps> = (props) => {
  const { formatNumericValue, percentageFormatter } = useNumberFormatter()

  const displayedPercentInteger = (): number | undefined => {
    const ratio = props.kpi.progressRatio
    if (!Number.isFinite(ratio)) {
      return undefined
    }
    // Percentages in this app are displayed without decimals.
    return Math.round(ratio * 100)
  }

  const isDisplayedAsZeroPercent = (): boolean => displayedPercentInteger() === 0

  return (
    <div class="relative flex w-full gap-1 items-center justify-between text-sm">
      <div class="flex gap-2 items-center">
        <Show when={props.warning}>
          <span class="text-red-500">
            <Icon icon="heroicons:exclamation-triangle-20-solid" class="text-[1rem]" />
          </span>
        </Show>

        <Show
          when={props.kpi.value !== undefined}
          fallback={
            <span class="text-gray-500">
              <Trans key="ls_generic_n_a" />
            </span>
          }
        >
          <span class="text-gray-700">{formatNumericValue(props.kpi.type, props.kpi.value)}</span>
        </Show>
      </div>
      <Show when={props.kpi.value !== undefined}>
        <Show
          when={isDisplayedAsZeroPercent()}
          fallback={
            <ProgressRatio
              value={props.kpi.progressRatio}
              prevValue={props.kpi.prevValue}
              type={props.kpi.type}
              kpi={props.kpi.id}
            />
          }
        >
          <div class="flex relative h-6 items-center justify-end min-w-[58px]">
            <span class="text-gray-700 font-semibold inline-flex items-center text-sm cursor-default">
              {percentageFormatter(0)}
            </span>
          </div>
        </Show>
      </Show>
    </div>
  )
}

export default ValueProgressCell
